<ol class="breadcrumb-list" [class.is--long]="breadCrumbs()?.length > 2">
  @for (breadcrumb of lastItems; track breadcrumb.url; let i = $index) {
    <li class="breadcrumb-list__item">
      @if (i) {
        <fstr-icon [ariaHidden]="true" class="breadcrumb-list__item__icon icon-xs" anchor="icon-arrow-right"></fstr-icon>
      }
      @if (breadcrumb?.hasLink) {
        <a class="breadcrumb-list__item__link has--link" [routerLink]="breadcrumb?.url">
          <span>{{ breadcrumb?.label === 'pagina' ? 'VKS' : breadcrumb?.label }}</span>
        </a>
      }
      @if (!breadcrumb?.hasLink) {
        <a [routerLink]="['/']" class="breadcrumb-list__item__link has--link">
          {{ breadcrumb?.label === 'pagina' ? 'VKS' : breadcrumb?.label }}
        </a>
      }
    </li>
  }
</ol>
